<template lang="pug">
  vueCustomScrollbar.scroll-area(:settings="settings")
    table#TbGrupos.table.is-striped.is-responsive(
        style="display:flex; justify-content:center; align-items:center; width:100% "
      )
      tbody(style='width:500px')
          tr(style='display:flex;')
            td(style='flex-grow:1') #
            td(style='flex-grow:1') Grupo
            td(style='flex-grow:1') Compañias
            td(style='flex-grow:1') Ver subgrupos
          tr(v-for="(data, index) in Comp" :key="data.id" style='')
            td
              a.button.is-black.is-rounded.is-small(style='margin-right:30px')
                |{{ index + 1 }}
            td {{ data.nombre }}
            td( colspan='2') 
              p(v-for="(datas) in data.companias" :key="datas.id_compania" style='margin-left:20px') {{ datas.compania }}
                button.button.is-light.is-rounded(@click="verSubgrupos(data.id, data.nombre, datas.id_compania, datas.compania)" style='margin-left:90px; margin-right:40px; ')
                  span.icon
                    i.fas.fa-eye
</template>

<script>
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import { mapState } from 'vuex'

  export default {
    name: 'TbGrupos',
    components: { vueCustomScrollbar },
    props: {
      Comp: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        settings: {
          maxScrollbarLength: 500
        },
      }
    },
    methods: { 
      verSubgrupos(idCompania, nombreCompania, idGrupo, nombreGrupo){
        this.$store.commit('idGrupoSelected', idCompania)
        this.$store.commit('nomCompaniaSelect', nombreGrupo)
        this.$store.commit('idCompaniaSelected', idGrupo)
        this.$store.commit('nomGrupoSelected', nombreCompania)
        
        this.$router.push('/IRGE/SCA/Subgrupos')
      }
    },
    created () {
    
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos']),
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/cuartocontrol/componentes/TbGrupos.vue